<template>
  <div class="apply-invoice">
    <div class="ceiling">
      <home-top></home-top>
      <navicat :current="-1" background="#FFFFFF"></navicat>
    </div>
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/user/purchase/order' }"
            >销售订单</el-breadcrumb-item
          >
          <el-breadcrumb-item>申请发票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="body-content">
        <div class="body-title">订单信息</div>
        <div class="address-box">
          <div class="address-title">发票信息</div>
          <div class="assress-content">
            <div class="user-name" v-if="detail.invoice">
              <span class="name">{{ detail.invoice.title }}</span>
              <span class="phone">{{ detail.invoice.tax_number }}</span>
            </div>
            <div class="address-detail" v-if="detail.invoice">
              <span>{{ detail.invoice.address }}</span>
            </div>
          </div>
        </div>
        <div class="order-info">
          <div class="order-info-title">订单信息</div>
          <el-table
            :data="orderList"
            style="width: 100%"
            border
            :header-cell-style="{
              background: '#F5F5F5',
              color: '#00112B',
              fontWeight: 'bold',
              textAlign: 'center',
            }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="product_name" label="商品名称" />
            <el-table-column prop="cas_no" label="CAS号" />
            <el-table-column prop="quantity" label="规格" />
            <el-table-column prop="unit_price" label="单价" />
            <el-table-column prop="number" label="数量" />
            <el-table-column prop="total_price" label="小计">
              <template slot-scope="scope">
                <span class="total-price">{{ scope.row.total_price }}元</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="submit">
          <gradient-button background="#387DF6" @hit="submit"
            >申请发票</gradient-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import navicat from "@/components/navicat/navicat.vue";
import { purchase_order_detail, apply_invoice } from "@/api/modules/user.js";
import GradientButton from "@/components/button/gradient-button.vue";
export default {
  name: "applyInvoice",
  components: {
    homeTop,
    navicat,
    GradientButton,
  },
  data() {
    return {
      order_id: this.$route.query.order_id,
      detail: {},
      orderList: [],
    };
  },
  created() {
    this.getOrderInfo();
  },
  methods: {
    submit() {
      apply_invoice(this.order_id).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.$router.push({
            path: "/user/purchase/order",
          });
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    getOrderInfo() {
      purchase_order_detail(this.order_id).then((res) => {
        let data = res.data.data;
        this.detail = data;
        this.orderList = [
          {
            product_name: data.product_name,
            cas_no: data.cas_no,
            quantity:  data.unit,
            unit_price: data.unit_price,
            number: data.cart_num ,
            total_price: data.total_price,
          },
        ];
      });
    },
  },
};
</script>
<style scoped lang="scss">
.total-price {
  font-weight: bold;
  font-size: 18px;
  color: #ff4400;
}
.content {
  // margin-top: 142px;
  // margin-top: 130px;
  .bread-crumb {
    padding: 20px 0;
  }
  .body-content {
    background-color: #fff;
    padding: 30px;
    .body-title {
      font-weight: 800;
      font-size: 20px;
      color: #00112b;
    }
    .address-box {
      box-sizing: border-box;
      .address-title {
        padding: 40px 0 30px;
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
      }
      .assress-content {
        background: #f5f5f5;
        border: 1px solid #d8d8d8;
        padding: 19px 40px;
        border-radius: 5px;
        .user-name {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          margin-bottom: 10px;
          .name {
            display: inline-block;
            margin-right: 20px;
          }
        }
        .address-detail {
          font-weight: 400;
          font-size: 18px;
          color: #5f616c;
        }
      }
    }
    .order-info {
      .order-info-title {
        padding: 40px 0 30px;
        font-weight: bold;
        font-size: 18px;
      }
    }
    .submit {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }
  }
}
</style>
